export const getLocale = () => {
    if (location.hash == "#/login?lang=zh_hk") return "zh_hk"
    else if (location.hash == "#/login?lang=zh_cn") return "zh_cn"
    else return localStorage.getItem("locale") || "en";
}

export const setLocale = (locale) => localStorage.setItem("locale", locale);
